import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, booleanAttribute } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Status } from 'src/app/model/enum/status';
import { Vcu } from 'src/app/model/form/vcu';
import { Image } from 'src/app/model/Image';
import { Load } from 'src/app/model/mockup/load-mockup';
import { VcuService } from 'src/app/service/vcu.service';

@Component({
  selector: 'app-card-vcu',
  templateUrl: './card-vcu.component.html',
  styleUrl: './card-vcu.component.css'
})
export class CardVcuComponent implements OnInit, OnChanges {

  @Input() vcu: Vcu | undefined = undefined;
  @Input({transform: booleanAttribute}) lastCard: boolean = false;
  @Input({transform: booleanAttribute}) lastCardLink: boolean = false;
  @Input({transform: booleanAttribute}) showUnlink: boolean = false;
  @Input({transform: booleanAttribute}) sharing: boolean = false;
  @Input() details: boolean | null = false

  @Output() unlink = new EventEmitter<any>();

  active: boolean;
  cardHeaderClass: string = '';
  subtitleClass: string = '';
  bodyClass: string = '';
  statusClass: string = '';
  polygonClass: string = '';
  cardClass: string = '';
  lastCardClass: string = 'none';
  labelLastCard: string = '';
  visible: boolean = false;
  descriptionStatus: string = '';
  isLoadingVcu: boolean = false;
  idAux: number = 0;
  lang: string = 'pt-br';

  constructor(
    private translocoService: TranslocoService,
    private router: Router,
    private vcuService: VcuService) {
    this.active = true;
    // this.vcu = VCU_1;
    // this.vcu = undefined;
    // this.vcu = VCU_2;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isLoadingVcu = true;
    // console.log('CHANGES CARD', changes)
    if(changes.vcu && changes.vcu?.currentValue !== changes.vcu?.previousValue) {
      // console.log('CHANGES CARD CURRENT', changes.vcu?.currentValue)
      this.vcu = changes.vcu?.currentValue;
      this.createCard();
    }
  }

  ngOnInit(): void {
    this.isLoadingVcu = true;
    let language = sessionStorage.getItem('language');
    if(language && language !== null)
      this.lang = language;
    this.changeLanguage();
    this.createCard();
  }
  
  createCard() {
   
    if(this.vcu !== undefined) {
      
      if(this.vcu.status == Status.ACTIVE) {
        this.statusClass = 'status-green';
      } else if(this.vcu.status == Status.DISABLED) {
        this.statusClass = 'status-red';
      } else if(this.vcu.status == Status.ACTIVATION_PENDING) {
        this.cardHeaderClass = 'card-header-pending';
        //this.subtitleClass = 'subtitle-pending';
        this.bodyClass = 'card-body-pending';
        this.polygonClass = 'polygon-pending';
        this.statusClass = 'status-yellow';
      }
      this.idAux += 1;
      this.vcuService.vcuImage(this.idAux,this.vcu).subscribe(img => {
        if (this.vcu) {
          this.vcu.image = img;
        }
      });
      this.statusToDescription(this.vcu.status);
    } else if(this.lastCard !== undefined) {
      if(this.lastCard) {
        this.lastCardClass = 'block';
        this.cardClass = 'none';
      }
    }
    // this.lastCardClass = 'block';
    if(this.lastCardLink) {
      this.translocoService.selectTranslate('vcu.card.link').subscribe(value => this.labelLastCard = value).unsubscribe();
    } else {
      this.translocoService.selectTranslate('vcu.card.new').subscribe(value => this.labelLastCard = value).unsubscribe();
    }
    this.isLoadingVcu = false;
  }

  formatImage(image: string | undefined | null) {
    if(image){
      return 'url('+image+')'; 
    }
    return ''
  }

  unlinkVcu() {
    this.unlink.emit();
  }
  
  goVcuDetail() {
    if(this.vcu){
      this.router.navigate(['/vcu/', this.vcu.id]);
    }
  }

  public changeLanguage(languageCode?: string | null): void {
    if(!languageCode || languageCode === null)
      languageCode = sessionStorage.getItem('language');
    if(languageCode && languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  statusToDescription(status: Status | null){
    this.descriptionStatus = '';
    if(status){
      if(status == Status.ACTIVE){
        this.translocoService.selectTranslate('vcu.status.ac').subscribe(value => 
          this.descriptionStatus = value
        ).unsubscribe();
      } else if(status == Status.ACTIVATION_PENDING){
        this.translocoService.selectTranslate('vcu.status.ap').subscribe(value => 
          this.descriptionStatus = value
        ).unsubscribe();
      } else if(status == Status.DISABLED){
        this.translocoService.selectTranslate('vcu.status.di').subscribe(value => 
          this.descriptionStatus = value
        ).unsubscribe();
      }
    }
  }
}
